import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TokenService } from 'services/token/token-service.service';
import { ConfigService } from 'services/config/config.service';
import { AppService } from 'services/app/app.service';

@Injectable()

export class AuthGuard implements CanActivate {
  constructor(
    public tokenService: TokenService,
    public router: Router,
    public appService: AppService,
    public configService: ConfigService,
  ) { }

  async canActivate(): Promise<boolean> {
    return new Promise(async (resolve: (r: boolean) => any, reject: (e: Error) => any) => {
      if (this.router.url.indexOf('/signin?') === 0) {
        return resolve(true);
      }
      if (!await this.tokenService.checkToken().toPromise()) {
        window.location.href = this.configService.getConfig().oidcUrl;
        return resolve(true);
      }
      return resolve(true);
    });
  }
}
